import React, { useMemo } from 'react'
import { Select, Typography } from 'antd'
import useDirectory from 'hooks/useDirectory'
import { AnnotationType } from 'types/building'

import DropdownIconCustom from 'components/icons/DropdownIconCustom'
import ConstructionYearInput from 'components/molecules/ConstructionYearInput'

export interface AnnotationTypeSelectorRNProps {
  selectedChildrenFolder?: any
  selectedFolder: AnnotationType
  changeSelectedFolder: (value: AnnotationType) => void
  year?: string
  onYearChange?: (year: string) => void
  t: (key: string, fallback?: string) => string
  onOpenAlertSetting?: () => void
  hasAlert?: boolean
}

export default function AnnotationTypeSelectorRN({
  selectedChildrenFolder = undefined,
  selectedFolder,
  changeSelectedFolder,
  year = '',
  onYearChange = undefined,
  t,
  onOpenAlertSetting = undefined,
  hasAlert = false
}: AnnotationTypeSelectorRNProps) {
  const { getAnnotationList } = useDirectory()

  const annotationList = useMemo(() => {
    const list = getAnnotationList() || []
    const hasSelected = list.some(
      (item: any) => Number(item.value) === Number(selectedFolder)
    )
    if (!hasSelected && selectedFolder) {
      if (Number(selectedFolder) === Number(AnnotationType.IMAGE)) {
        return [
          ...list,
          {
            value: AnnotationType.IMAGE,
            label: t('building.tourAnnotationType.image', 'ピクチャ')
          }
        ]
      }
      if (Number(selectedFolder) === Number(AnnotationType.MOVIE)) {
        return [
          ...list,
          {
            value: AnnotationType.MOVIE,
            label: t('building.tourAnnotationType.movie', 'ムービー')
          }
        ]
      }
      if (Number(selectedFolder) === Number(AnnotationType.INFO)) {
        return [
          ...list,
          {
            value: AnnotationType.INFO,
            label: t('building.tourAnnotationType.info', 'インフォ')
          }
        ]
      }
    }
    return list
  }, [getAnnotationList, selectedFolder, t])

  if (selectedChildrenFolder && selectedFolder !== AnnotationType.MEMO) {
    return null
  }

  return (
    <div className="flex gap-[5.5rem] items-center h-10 mb-[10px] w-full">
      <Typography className="font-bold text-[14px] leading-[14px] text-[#021120]">
        {t('building.annotationType')}
      </Typography>
      <Select
        value={selectedFolder}
        onSelect={changeSelectedFolder}
        options={annotationList}
        suffixIcon={<DropdownIconCustom colorIcon="#000000" />}
        style={{
          width: 240,
          fontSize: 14,
          color: '#021120'
        }}
      />

      {selectedFolder !== AnnotationType.MEMO && (
        <div className="flex items-center gap-2">
          <Typography className="font-bold text-[14px] leading-[14px] text-[#021120] whitespace-nowrap">
            施工年
          </Typography>
          <ConstructionYearInput value={year} onChange={onYearChange} />
        </div>
      )}

      <div className="ml-auto flex flex-col items-end justify-center relative -top-1 gap-1">
        <span
          className={`text-[10px] leading-3 font-bold ${
            hasAlert ? 'text-[#3451D1]' : 'text-[#E73A3A]'
          }`}
        >
          {hasAlert ? '設定中' : '未設定'}
        </span>
        <div
          className="flex items-center justify-center border border-solid border-[#3451D1] text-[#3451D1] rounded cursor-pointer px-4 h-[30px] text-[12px] font-bold bg-white"
          onClick={() => {
            if (onOpenAlertSetting) {
              onOpenAlertSetting()
            }
          }}
        >
          アラート設定
        </div>
      </div>
    </div>
  )
}

AnnotationTypeSelectorRN.defaultProps = {
  selectedChildrenFolder: undefined,
  year: '',
  onYearChange: undefined,
  onOpenAlertSetting: undefined,
  hasAlert: false
}
